module.exports = __webpack_public_path__ + "img/jameson-form-bg-left-1.32b1d9b0.svg";